"use strict";
// tslint:disable
/**
 * Laravel WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteTypeEnum = exports.QuoteToJSON = exports.QuoteFromJSONTyped = exports.QuoteFromJSON = void 0;
var runtime_1 = require("../runtime");
function QuoteFromJSON(json) {
    return QuoteFromJSONTyped(json, false);
}
exports.QuoteFromJSON = QuoteFromJSON;
function QuoteFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'barcode': json['barcode'],
        'courierSlug': !runtime_1.exists(json, 'courier_slug') ? undefined : json['courier_slug'],
        'courierName': !runtime_1.exists(json, 'courier_name') ? undefined : json['courier_name'],
        'lockerName': !runtime_1.exists(json, 'locker_name') ? undefined : json['locker_name'],
        'credits': json['credits'],
        'shipping': !runtime_1.exists(json, 'shipping') ? undefined : json['shipping'],
        'type': json['type'],
    };
}
exports.QuoteFromJSONTyped = QuoteFromJSONTyped;
function QuoteToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'barcode': value.barcode,
        'courier_slug': value.courierSlug,
        'courier_name': value.courierName,
        'locker_name': value.lockerName,
        'credits': value.credits,
        'shipping': value.shipping,
        'type': value.type,
    };
}
exports.QuoteToJSON = QuoteToJSON;
/**
* @export
* @enum {string}
*/
var QuoteTypeEnum;
(function (QuoteTypeEnum) {
    QuoteTypeEnum["Inperson"] = "inperson";
    QuoteTypeEnum["Locker"] = "locker";
    QuoteTypeEnum["Pickup"] = "pickup";
})(QuoteTypeEnum = exports.QuoteTypeEnum || (exports.QuoteTypeEnum = {}));
